import ProductRow from "../ProductRow";
import { Grid2, Typography } from "@mui/material";

import classes from './index.module.scss';

const MaterialMemberArea = ({ material, company }) => {
  // skip probably empty dummy '' material
  if (material.productList.length === 0) {
    return null;
  }

  return (
    <>
      {
        material.name ? (
          <Grid2 size={12} className={classes.row}>
            <Typography variant="body1">{material.name}</Typography>
          </Grid2>
        ) : null
      }
      <Grid2 size={12}>
        {
          material.productList.map((product) => {
            return (
              <ProductRow product={product} key={product.productName} company={company} />
            )
          })
        }
      </Grid2>
    </>
  )
}

export default MaterialMemberArea;